import { Component, Input, OnInit } from '@angular/core';
import { Params } from '@angular/router';

@Component({
  selector: 'app-total-active-column',
  templateUrl: './total-active-column.component.html',
  styleUrls: ['./total-active-column.component.scss'],
})
export class TotalActiveColumnComponent implements OnInit {

  @Input() total: number;
  @Input() active: number;
  @Input() groupId: number;
  @Input() groupName: string;

  constructor() {
  }

  get route() {
    return ['/user_contacts', this.groupId, 'contacts'];
  }

  ngOnInit(): void {
  }

  getTotalQueryParams(): Params {
    return {
      group_name: this.groupName,
      filter: 'all',
    };
  }

  getActiveQueryParams(): Params {
    return {
      group_name: this.groupName,
      filter: 'active',
    };
  }
}
